module.exports = {
  fontFamily: {
    'sans': ['Figtree', 'sans-serif'],
    'display': ['Figtree', 'sans-serif'],
    'serif': ['Georgia', 'serif'],
  },
}
